import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_merch_toolkit_offer_pinning_guardrail_v1",
  stages: {},
  defaultStage: 1,
  goals: {
    featured_offer_click: 1,
    next_search_page_navigation: 2,
    featured_info_displayed: 3
  }
});

export default utils;
